import { GenIcon } from '../helpers/IconBase.es.js';

const CashOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.8058 7.5H20C20.2761 7.5 20.5 7.72386 20.5 8V9.19425C19.6588 9.00337 18.9966 8.34119 18.8058 7.5ZM17.283 7.5H6.71696C6.4943 9.17111 5.17111 10.4943 3.5 10.717V13.283C5.17111 13.5057 6.4943 14.8289 6.71696 16.5H17.283C17.5057 14.8289 18.8289 13.5057 20.5 13.283V10.717C18.8289 10.4943 17.5057 9.17111 17.283 7.5ZM20.5 14.8058C19.6588 14.9966 18.9966 15.6588 18.8058 16.5H20C20.2761 16.5 20.5 16.2761 20.5 16V14.8058ZM5.19425 16.5C5.00337 15.6588 4.34119 14.9966 3.5 14.8058V16C3.5 16.2761 3.72386 16.5 4 16.5H5.19425ZM3.5 9.19425C4.34119 9.00337 5.00337 8.34119 5.19425 7.5H4C3.72386 7.5 3.5 7.72386 3.5 8V9.19425ZM2 8C2 6.89543 2.89543 6 4 6H20C21.1046 6 22 6.89543 22 8V16C22 17.1046 21.1046 18 20 18H4C2.89543 18 2 17.1046 2 16V8ZM12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { CashOutlined };
